import React from 'react';
import './meeting-preview.css';
import { Icon } from '../../../components/icon';
import { Paragraph } from '../../../components/paragraph';
import { IconButton } from '../../../components/icon-button';
import classNames from 'classnames';

const MeetingPreview = props => {
    const {
        title,
        attendee,
        meetingIcon,
        meetingLocation,
        onClick,
        modalVisible,
    } = props;

    const attendeeImageClasses = classNames({
        'meeting-preview__attendee': true,
        'meeting-preview__attendee--parliament': meetingIcon === 'parliament',
        'meeting-preview__attendee--constituency':
            meetingIcon === 'constituency',
    });

    return (
        <div className="meeting-preview">
            <div className={attendeeImageClasses}>
                <Icon iconName="attendee" size="large" />
            </div>
            <div className="meeting-preview__text">
                <Paragraph colorScheme="light" withSpacing={false}>
                    {title}
                </Paragraph>
                <Paragraph colorScheme="light" withSpacing={false}>
                    {attendee}
                </Paragraph>
                <Paragraph colorScheme="light" withSpacing={false}>
                    Location {meetingLocation}
                </Paragraph>
            </div>
            <IconButton
                onClick={onClick}
                iconName="arrow"
                size="small"
                type="main"
                isDisabled={modalVisible}
                altText="choose meeting"
            />
        </div>
    );
};

export { MeetingPreview };
